import { lightHelmColor } from '../tokens/customColor';
import { lightSailColor } from '../tokens/color';
export const lightSailColorTokens = lightSailColor;
export const lightHelmColorTokens = lightHelmColor;

//# sourceMappingURL=Light.js.map